import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
  Box
} from "@mui/material";

const PopupConfirmacao = ({ open, onClose, onConfirm }) => {
  const [aceitouTermos, setAceitouTermos] = useState(false);
  const [aceitouLGPD, setAceitouLGPD] = useState(false);

  const handleConfirm = () => {
    if (aceitouTermos && aceitouLGPD) {
      onConfirm();
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirmação de Envio</DialogTitle>
      <DialogContent>
        <Typography mb={2}>
          Ao preencher as informações e enviar os documentos necessários para o cadastro de sua empresa como fornecedor de tecnologia no banco de dados do SENAI, você:
        </Typography>
        <Typography component="ul" mb={2}>
          <li>Atesta ter a devida autonomia para realizar este procedimento em nome da empresa.</li>
          <li>Garante que todas as informações fornecidas são verdadeiras e precisas.</li>
          <li>Compromete-se a manter o cadastro atualizado conforme necessário.</li>
        </Typography>
        <FormControlLabel
          control={<Checkbox checked={aceitouTermos} onChange={(e) => setAceitouTermos(e.target.checked)} />}
          label="Eu estou de acordo com os termos acima."
        />

        <Box mt={3}>
          <Typography variant="body2" mb={1}>
            Ao prosseguir, você concorda com a coleta, armazenamento e tratamento dos seus dados apresentados de acordo com a Lei Geral de Proteção de Dados (LGPD). Seus dados serão usados exclusivamente para verificação da elegibilidade da empresa para compor o banco de fornecedores do SENAI e não serão compartilhados sem o seu consentimento expresso.
          </Typography>
          <FormControlLabel
            control={<Checkbox checked={aceitouLGPD} onChange={(e) => setAceitouLGPD(e.target.checked)} />}
            label="Concordo com os termos de LGPD."
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          color="primary"
          disabled={!aceitouTermos || !aceitouLGPD}
          onClick={() => {
            if (aceitouTermos && aceitouLGPD) {
              onConfirm(); 
              onClose();
            }
          }}
        >
          Enviar processo para análise
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PopupConfirmacao;
